<template>
  <Expired
    :title="$t('payment.success_title')"
    :text="$t('payment.success_text')"
  ></Expired>
</template>

<script>
import Expired from "@/components/auth/Expired";

export default {
  components: {
    Expired,
  },
};
</script>
